module.exports = __webpack_public_path__ + "assets/e011257435fcd56b6beea6655a3ed97f.jpg";